const PLAYER_NAME_KEY = "our-story-player-name";

export const getLastPlayerName = (): string => localStorage.getItem(PLAYER_NAME_KEY) || "";

export const setLastPlayerName = (playerName: string): void =>
  localStorage.setItem(PLAYER_NAME_KEY, playerName);
